/**
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import QRious from 'qrious';
import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-qr.html';

import focus from '../focus/focus-directive';
import * as SetupManager from './setup-manager';

export default defineComponent({
  name: 'SetupQr',
  template,
  data() {
    return {
      /** @type {boolean} */
      isHttps: this.serverUrl.startsWith('https://')
    };
  },
  directives: { focus },
  emits: {
    manual() {},
    settings() {},
    storage() {},
    statusInfo() {}
  },
  methods: {
    onManual() {
      this.$emit('manual');
    },
    onSettings() {
      this.$emit('settings');
    },
    onStatusInfo() {
      this.$emit('statusInfo');
    },
    onStorage() {
      this.$emit('storage');
    }
  },
  mounted() {
    // eslint-disable-next-line no-new
    new QRious({
      element: this.$refs.canvasEl,
      level: 'L',
      size: 500,
      value: SetupManager.getQrUrl(this.serverUrl, this.fingerprint)
    });
  },
  props: {
    editableServerUrl: { type: Boolean, required: true },
    fingerprint: { type: String, required: true },
    serverUrl: { type: String, required: true }
  }
});
